import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import BrandLogo from "./BrandLogo";

const NAV = [
  { label: "WHY US", href: "/#why" },
  { label: "PODCASTS", href: "/#heard" },
  { label: "ANNUITY TV", href: "/#seen" },
  { label: "MAGAZINE", href: "/magazine" },
  { label: "APPLY", href: "/#apply" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - lastY;

        setScrolled(y > 30);

        // Always show near the top
        if (y < 80) {
          setHidden(false);
        } else if (delta > 6) {
          // Scrolling DOWN - hide
          setHidden(true);
          setOpen(false);
        } else if (delta < -6) {
          // Scrolling UP - show
          setHidden(false);
        }

        lastY = y;
        ticking = false;
      });
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all duration-300 ${
        scrolled
          ? "bg-[#050608]/50 backdrop-blur-xl border-b border-white/10"
          : "bg-[#050608]/35 backdrop-blur-md border-b border-white/5"
      } ${hidden ? "-translate-y-full" : "translate-y-0"}`}
    >
      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-4 flex items-center justify-between gap-8">
        {/* Brand */}
        <a href="#top" className="shrink-0 group">
          <BrandLogo size="md" />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.label}
              href={n.href}
              className="text-[12px] tracking-[0.22em] font-semibold text-white/70 hover:text-[#f5c451] transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 right-0 h-px bg-[#f5c451] scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="flex items-center gap-3">
          <a href="#apply" className="hidden sm:block">
            <Button className="btn-gold rounded-md h-11 px-6 text-xs tracking-[0.14em] font-display">
              APPLY NOW
            </Button>
          </a>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-white/15 text-white"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#050608]/95 backdrop-blur-md">
          <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] font-semibold text-white/80 hover:text-[#f5c451]"
              >
                {n.label}
              </a>
            ))}
            <a href="#apply" onClick={() => setOpen(false)}>
              <Button className="btn-gold rounded-md h-11 w-full text-xs tracking-[0.14em] font-display mt-2">
                APPLY NOW
              </Button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
